import { render, staticRenderFns } from "./faculties.vue?vue&type=template&id=e810cdb0&"
import script from "./faculties.vue?vue&type=script&lang=js&"
export * from "./faculties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports